"use client";

import { useEffect, useState } from "react";
import { Clock, MapPin } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const offices = [{
  code: "TLX-01",
  name: "ORBITAL COMMAND / HQ",
  address: "\n",
  description: "Our primary command center, orchestrating real-time satellite telemetry and orbital intelligence across all global sectors.",
  timezone: "CST",
  tzOffset: -6,
  cx: 27,
  cy: 38,
  cardPosition: "top-left",
  hours: "Mon-Fri 07:00 - 19:00",
  coverage: "North American Sector",
  lead: "Dr. Sarah Vance"
}, {
  code: "TLX-02",
  name: "EUROPEAN LINK / EMEA",
  address: "\n",
  description: "Our European node bridges institutional aerospace partners with deep signal processing and orbital market intelligence.",
  timezone: "CET",
  tzOffset: 1,
  cx: 49,
  cy: 32,
  cardPosition: "bottom-right",
  hours: "Mon-Fri 08:00 - 18:00",
  coverage: "EMEA Intelligence Grid",
  lead: "Marcus Thorne"
}, {
  code: "TLX-03",
  name: "PACIFIC NODE / APAC",
  address: "\n",
  description: "Our APAC node delivers advanced sensor forecasting and orbital tracking across the world's most dynamic technology markets.",
  timezone: "JST",
  tzOffset: 9,
  cx: 84,
  cy: 40,
  cardPosition: "top-right",
  hours: "Mon-Fri 09:00 - 19:00",
  coverage: "Asia Pacific Grid",
  lead: "Kenji Tanaka"
}];
function getOfficeTime(offsetHours: number) {
  const now = new Date();
  const utc = now.getTime() + now.getTimezoneOffset() * 60000;
  const local = new Date(utc + offsetHours * 3600000);
  const hh = local.getHours().toString().padStart(2, "0");
  const mm = local.getMinutes().toString().padStart(2, "0");
  return `${hh}:${mm}`;
}
export default function Headquarters() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const [times, setTimes] = useState(offices.map(o => getOfficeTime(o.tzOffset)));
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
  useEffect(() => {
    const t = setInterval(() => {
      setTimes(offices.map(o => getOfficeTime(o.tzOffset)));
    }, 30000);
    return () => clearInterval(t);
  }, []);
  return <>
      {false && <section data-section-id="5091" id="operational-headquarters" ref={ref} className="bg-[#080F1A] text-[#B2BDC7] py-24 md:py-48 px-6 md:px-12 overflow-hidden">
          <div className="max-w-[1440px] mx-auto grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 mb-16 md:mb-24">
        <div className="lg:col-span-7 flex gap-5">
          <div className="w-px shrink-0 self-stretch" style={{
            backgroundColor: "#6697B9"
          }} />
          <div className={`transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            <div className="font-mono text-sm uppercase tracking-[0.2em] mb-6" style={{
              color: "#6697B9"
            }}><br /></div>
            <h2 className="font-default font-bold text-5xl md:text-6xl leading-[1.1] tracking-[-0.02em] uppercase text-[#B2BDC7]">
              Commanding
              <br />
              <span style={{
                color: "#6697B9"
              }}>Intelligence</span>
            </h2>
          </div>
        </div>

        <div className="lg:col-span-5 flex flex-col justify-end gap-6">
          <p className={`font-default text-xl leading-relaxed text-[#B2BDC7] max-w-[420px] transition-all duration-700 delay-100 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            TiaLinx, Inc. maintains three strategic orbital intelligence hubs positioned across the world's most consequential aerospace centers, enabling unbroken real-time sensing for our high-end clientele.
          </p>
          
        </div>
      </div>

      <div className="max-w-[1440px] mx-auto hidden md:block">
        <div className="relative w-full border border-[#45596F]" style={{
          aspectRatio: "21 / 9",
          backgroundColor: "#080F1A"
        }}>
          <svg viewBox="0 0 100 50" preserveAspectRatio="none" className="absolute inset-0 w-full h-full">
            <g stroke="#45596F" strokeWidth="0.05" opacity="0.1">
              {[...Array(11)].map((_, i) => <line key={`v-${i}`} x1={i * 10} y1="0" x2={i * 10} y2="50" />)}
              {[...Array(6)].map((_, i) => <line key={`h-${i}`} x1="0" y1={i * 10} x2="100" y2={i * 10} />)}
            </g>

            <g fill="#45596F" stroke="#507697" strokeWidth="0.1">
              <path d="M 8,18 L 14,14 L 22,12 L 30,14 L 34,18 L 32,24 L 28,30 L 24,34 L 20,32 L 16,28 L 12,24 Z" />
              <path d="M 26,34 L 30,36 L 32,42 L 30,48 L 26,46 L 24,40 Z" />
              <path d="M 44,18 L 50,16 L 54,18 L 52,22 L 48,24 L 44,22 Z" />
            </g>

            <g fill="none" stroke="#6697B9" strokeWidth="0.15" strokeDasharray="0.6 0.6" opacity="0.55">
              <path d="M 27,38 Q 38,18 49,32" />
              <path d="M 49,32 Q 66,12 84,40" />
            </g>
          </svg>

          <div className="absolute inset-0">
       {offices.map((office, i) => {
              const isHovered = hoveredIndex === i;
              return <div key={office.code} className="absolute" style={{
                left: `${office.cx}%`,
                top: `${office.cy}%`
              }} onMouseEnter={() => setHoveredIndex(i)} onMouseLeave={() => setHoveredIndex(null)}>
      <span className="absolute -translate-x-1/2 -translate-y-1/2 left-0 top-0 block w-2 h-2" aria-hidden>
        <span className="absolute inset-0 animate-ping" style={{
                    backgroundColor: "#6697B9"
                  }} />
      </span>

      <span className="absolute -translate-x-1/2 -translate-y-1/2 left-0 top-0 block w-2 h-2 z-10" style={{
                  backgroundColor: "#6697B9"
                }} />

      <div className={`absolute w-[280px] p-6 border transition-all duration-300 ${office.cardPosition === "top-left" ? "right-full bottom-full mr-6 mb-6" : "left-full top-full ml-6 mt-6"}`} style={{
                  backgroundColor: "#080F1A",
                  borderColor: isHovered ? "#6697B9" : "#45596F"
                }}>
        <div className="font-default font-semibold text-lg uppercase mb-3 text-[#B2BDC7]">
          {office.name}
        </div>

        <div className="font-mono text-[10px] uppercase tracking-wider mb-3 text-[#507697]">
          {office.address}
        </div>

        <p className="font-default text-sm leading-relaxed text-[#B2BDC7]/80 mb-4">
          {office.description}
        </p>

        <div className="flex items-center gap-2 font-mono text-[12px] pt-3 border-t border-[#45596F]">
          <span className="inline-block w-1.5 h-1.5" style={{
                      backgroundColor: "#6697B9"
                    }} />

          <span className="uppercase tracking-wider" style={{
                      color: "#6697B9"
                    }}>
            UPLINK: {times[i]} {office.timezone}
          </span>
        </div>
      </div>
    </div>;
            })}
 </div>
      </div>
    </div>

      
     <div className="max-w-[1440px] mx-auto mt-24 grid grid-cols-1 md:grid-cols-3 gap-px border border-[#45596F] bg-[#45596F]">
  {offices.map((office, i) => <div key={office.code} className="p-10 bg-[#080F1A]">
      <div className="font-mono text-[10px] uppercase tracking-[0.2em] mb-6 flex items-center gap-2" style={{
            color: "#6697B9"
          }}>
        <MapPin className="size-3" />
        {office.code} / STATUS
      </div>

      <div className="space-y-6">
        <div>
          <div className="font-mono text-[9px] uppercase tracking-[0.2em] text-[#507697] mb-2">
            Operating Hours
          </div>
          <div className="font-default text-lg font-medium text-[#B2BDC7]">
            {office.hours}
          </div>
        </div>

        <div>
          <div className="font-mono text-[9px] uppercase tracking-[0.2em] text-[#507697] mb-2">
            Sector Coverage
          </div>
          <div className="font-default text-lg font-medium text-[#B2BDC7]">
            {office.coverage}
          </div>
        </div>

        <div>
          <div className="font-mono text-[9px] uppercase tracking-[0.2em] text-[#507697] mb-2">
            Mission Lead
          </div>
          <div className="font-default text-lg font-medium text-[#B2BDC7]">
            {office.lead}
          </div>
        </div>
      </div>
    </div>)}
      </div>
    </section>}
  </>;
}